import React from 'react';
import PropTypes from 'prop-types';
import {
    HorizontalFlex,
    Label,
    PadContainer,
    Toggles,
    Toggle,
} from 'smartsuite-ui';
import { useLabelContext } from '../../../../shared/hooks/labelContext';

export default function ActionedBagsToggle(props) {
    const { dashboardLabels, translationLabels } = useLabelContext();

    return (
        <HorizontalFlex cssClassModifiers={['justify-flex-end']}>
            <Label>{`${dashboardLabels.actionedBags}:`}</Label>
            <PadContainer cssClassModifiers={['pad-small']} />
            <Toggles>
                <Toggle
                    isActive={props.isActive}
                    onClick={() => props.onClick(true)}
                >
                    {`${translationLabels.show}`}
                </Toggle>
                <Toggle
                    isActive={!props.isActive}
                    onClick={() => props.onClick(false)}
                >
                    {`${translationLabels.hide}`}
                </Toggle>
            </Toggles>
        </HorizontalFlex>
    );
}

ActionedBagsToggle.propTypes = {
    isActive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
